<template>
  <div class="section_wrap">
    <div class="head">
      <!-- <div class="head-left"></div> -->
      <div class="head-center">
        <div class="title">
          <div class="title-text">新闻报道</div>
          <div class="title-icon" @click="toMoreData()">
            <el-image class="elimage" :src="moreicon" />
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="showcase">
        <template v-if="listData.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in listData" :key="index" @click="toDetail(item)">
              <div class="goods-item--img" v-if="item.cover">
                <el-image class="image" :src="item.cover" @error="handleError" />
              </div>
              <div class="goods-item--text">
                <div class="goods-item-date">
                  <div class="date">{{ item.month }}-{{ item.day }}</div>
                  <div class="year">{{ item.year }}</div>
                  <div class="icon"></div>
                </div>
                <div class="goods-item-info">
                  <div class="title multiple-ellipsis">{{ item.title }}</div>
                  <div class="content multiple-ellipsis">
                    <span class="txt" v-html="item.content"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/api/activity"
import dayjs from "dayjs"
export default {
  name: "homeNews",
  components: {},
  data() {
    return {
      queryParams: {
        per_page: 4,
        page: 1,
      },
      listData: [],
      moreicon: require("@/assets/home/more.png"),
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  mounted() {
    this.getList()
  },
  methods: {
    handleError(e) {
      e.target.src = this.goodsimage
    },
    // 获取列表数据
    getList() {
      getNewsList(this.queryParams).then((res) => {
        if (res.code === 0) {
          let resData = res.data?.data?.map(item => {
            let dateStr = dayjs.unix(item.updated_at).format("YYYY-MM-DD").split('-')
            item.year = dateStr[0]
            item.month = dateStr[1]
            item.day = dateStr[2]
            return item
          })
          this.listData = resData
        }
      }).catch(() => { })
    },
    // 加载更多数据
    toMoreData() {
      window.localStorage.setItem("menuId", 2)
      this.$store.dispatch("setmenuid", 2)
      this.$router.push({
        path: "/home/news/mainpage",
      })
    },
    toDetail(item) {
      window.localStorage.setItem("menuId", 2)
      this.$store.dispatch("setmenuid", 2)
      this.$router.push({
        path: "/home/news/detail",
        query: {
          id: item.id || "",
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;

  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;

    // margin-bottom: 30px;
    .head-left {
      width: 64px;
    }

    .head-center {

      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;

        // padding: 0 10px;
        .title-icon {
          width: 32px;
          min-width: 32px;
          height: 32px;
          margin-left: 10px;

          .elimage {
            width: 100%;
            height: 100%;
          }
        }

        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }

    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;

        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }

  .body {
    .showcase {

      // margin: 0 -10px;
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .goods-item {
          display: flex;
          width: calc((100% - 25px) / 2);
          height: 215px;
          margin-top: 30px;
          background-color: #fff;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;

          // &:hover {
          //   border: 1px solid rgb(9, 235, 178);
          // }
          .goods-item--img {
            width: 285px;
            min-width: 285px;
            height: 100%;
            background: aliceblue;
            overflow: hidden;

            .image {
              display: inline-block;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: transform;
              transition-property: transform;
              -webkit-transform: translateZ(0);
              transform: translateZ(0);
              box-shadow: 0 0 1px rgba(0, 0, 0, 0);
            }

            .image:hover,
            .image:focus,
            .image:active {
              -webkit-transform: scale(1.1);
              transform: scale(1.1);
            }

            .image {
              width: 100%;
              height: 100%;
            }
          }

          .goods-item--text {
            width: calc(100% - 285px);
            background-color: #fff;
            padding: 30px;
            display: flex;

            .goods-item-date {
              width: 130px;
              min-width: 70px;
              padding: 0px 30px;
              box-sizing: border-box;

              .date {
                color: #000000;
                font-size: 24px;
                font-weight: 500;
                line-height: 40px;
              }

              .year {
                color: #999999;
                font-size: 12px;
                font-weight: 400;
                line-height: 30px;
              }

              .icon {
                width: 30px;
                height: 30px;
                background: url('~@/assets/home/details_gray.png') no-repeat;
                background-position: center;
                background-size: cover;
                margin-top: 20px;
              }

              &:hover .icon {
                transform: translateX(50%);
                transition: 0.4s all;
              }
            }

            .goods-item-info {
              flex: 1;

              .title {
                color: #000000;
                font-size: 18px;
                font-weight: 500;
                margin-bottom: 10px;
                -webkit-line-clamp: 2 !important;
              }

              .content {
                word-break: break-all;
                white-space: pre-wrap;
                overflow-wrap: break-word;

                .txt {
                  color: #333;
                  font-size: 12px;
                  font-weight: 400;
                  text-align: justify;
                  line-height: 20px;
                  border-radius: 12px;
                  margin-bottom: 10px;
                }
              }
            }
          }
        }

        .goods-item:nth-child(even) {
          margin-left: 25px;
        }
      }
    }
  }
}

.el-empty--cont {
  padding: 0px;
  min-height: 200px;
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-text {
            font-size: 20px;
          }

          .title-icon {
            width: 24px;
            min-width: 24px;
            height: 24px;
          }
        }
      }
    }

    .body {
      .showcase {
        .goods-list {
          .goods-item {
            width: 100%;
            flex-direction: column;
            height: auto;
            margin-top: 15px;

            .goods-item--img {
              width: 100%;
              min-width: 100%;
              height: 180px;
            }

            .goods-item--text {
              width: calc(100% - 25px);
              flex-direction: column;
              padding: 12px;

              .goods-item-date {
                width: 100%;
                padding: 0;
                display: flex;
                flex-direction: row;
                align-items: center;
                margin-bottom: 8px;

                .date {
                  font-size: 14px;
                  line-height: 1.5;
                  margin-right: 8px;
                }

                .year {
                  font-size: 12px;
                  line-height: 1.5;
                  color: #999;
                }

                .icon {
                  display: none;
                }
              }

              .goods-item-info {
                .title {
                  font-size: 14px;
                }

                .content {
                  font-size: 12px;

                  .txt {
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .goods-item:nth-child(even) {
            margin-left: 0;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .body {
      .showcase {
        .goods-list {
          .goods-item {
            .goods-item--img {
              width: 200px;
              min-width: 200px;
            }

            .goods-item--text {
              width: calc(100% - 200px);
            }
          }
        }
      }
    }
  }
}
</style>